import { openDB } from "idb";

const DB_NAME = "apiCache";
const DB_VERSION = 1; // Keep this version fixed unless changing schema
const STORE_NAME = "responses";

async function getDB() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
}

export async function saveToCache(key, data) {
  const db = await getDB();
  await db.put(STORE_NAME, data, key);
}

export async function getFromCache(key) {
  const db = await getDB();
  return db.get(STORE_NAME, key);
}

export async function clearCache() {
  const db = await getDB();
  await db.clear(STORE_NAME);
}
